import styled from "styled-components";

export const ColorSuffixSC = styled.div<{ color: string }>`
  height: 24px;
  width: 24px;
  border-radius: 50%;
  border: 1px solid black;
  background: ${({ color }) => color};
`;
